import * as CatalogClient from '@shawfloors/catalog-client';

import * as Storage from 'Utils/Storage';
import cacheKey from './CacheKey';

export function getColorFavorites(): Promise<TrykApi.Catalog.IColorFavorites[]> {
  return Storage.addOrGetItemAsync(
    cacheKey('favorites', 'colors'),
    () => CatalogClient.ColorFavorites.getColorFavorites(),
    false);
}

export function saveColorFavorites(colorFavorites: TrykApi.Catalog.IColorFavorites[]): Promise<boolean> {
  Storage.setItem(
    cacheKey('favorites', 'colors'),
    colorFavorites,
    false);

  return CatalogClient.ColorFavorites.saveColorFavorites(colorFavorites);
}

export function clearColorFavorites(): Promise<boolean> {
  Storage.removeItem(cacheKey('favorites', 'colors'));

  return Promise.resolve(true);
}
